import { FunctionComponent } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Textarea,
} from "@chakra-ui/react";

import { size } from "src/types/size";

type Props = {
  placeholder?: string;
  type:
    | "email"
    | "text"
    | "search"
    | "textarea"
    | "select"
    | "datetime-local"
    | "date"
    | "month"
    | "file"
    | "password"
    | "url";
  value: string;
  handleChange?: (val: any) => void;
  name?: string;
  handleBlur?: (val: any) => void;
  handleKeydown?: any;
  variant?: "outline" | "filled" | "flushed";
  size?: size;
  isInvalid?: boolean;
  label?: string;
  errorBorderColor?: string;
  border?: string;
  focusBorderColor?: boolean;
  isError?: boolean;
  isRequired?: boolean;
  errorMessage?: string;
  maxLength?: number;
  disabled?: boolean;
  resize?: "none";
  className?: string;
  accept?: string;
  rows?: number;
};

export const CustomInput: FunctionComponent<Props> = ({
  placeholder,
  size,
  variant,
  handleChange,
  handleBlur,
  handleKeydown,
  name,
  type,
  isInvalid,
  label,
  errorBorderColor,
  value,
  border,
  focusBorderColor,
  isError,
  isRequired,
  errorMessage,
  maxLength,
  disabled,
  resize,
  className,
  accept,
  rows,
}) => {
  if (type === "textarea") {
    return (
      <FormControl isInvalid={isError} isRequired={isRequired}>
        {label && (
          <FormLabel fontSize={"13px"} color={"#0B0A0A"}>
            {label}
          </FormLabel>
        )}
        <Textarea
          placeholder={placeholder}
          size={size}
          variant={variant}
          onChange={handleChange}
          onBlur={handleBlur}
          name={name}
          isInvalid={isInvalid}
          errorBorderColor={errorBorderColor}
          value={value}
          bg={"white"}
          border={border}
          focusBorderColor={focusBorderColor && "transparent"}
          maxLength={maxLength}
          disabled={disabled}
          resize={resize}
          className={className}
          rows={rows}
        />
        {isError && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
      </FormControl>
    );
  }
  return (
    <FormControl isInvalid={isError} isRequired={isRequired}>
      {label && (
        <FormLabel fontSize={"13px"} color={"#0B0A0A"}>
          {label}
        </FormLabel>
      )}
      <Input
        placeholder={placeholder}
        size={size}
        variant={variant}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeydown}
        type={type}
        name={name}
        isInvalid={isInvalid}
        errorBorderColor={errorBorderColor}
        value={value}
        bg={"white"}
        border={border}
        focusBorderColor={focusBorderColor && "transparent"}
        maxLength={maxLength}
        disabled={disabled}
        className={className}
        accept={accept}
      />
      {isError && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </FormControl>
  );
};
